import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── SMS Templates (/api/sms-templates) ──────────────────────────────────

export interface SmsTemplate {
  id: string;
  workspace_id: string;
  name: string;
  body: string;
  outcome_filter?: string | null;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export async function fetchSmsTemplates(workspaceId?: string, axiosInstance?: AxiosInstance): Promise<SmsTemplate[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<SmsTemplate[]>(apiConfig.voiceEndpoints.smsTemplates, { params: workspaceId ? { workspace_id: workspaceId } : undefined });
  return response.data;
}

export async function createSmsTemplate(data: { name: string; body: string; outcome_filter?: string | null; is_default?: boolean }, workspaceId?: string, axiosInstance?: AxiosInstance): Promise<SmsTemplate> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<SmsTemplate>(apiConfig.voiceEndpoints.smsTemplates, data, { params: workspaceId ? { workspace_id: workspaceId } : undefined });
  return response.data;
}

export async function updateSmsTemplate(id: string, data: Partial<{ name: string; body: string; outcome_filter: string | null; is_default: boolean }>, axiosInstance?: AxiosInstance): Promise<SmsTemplate> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.put<SmsTemplate>(`${apiConfig.voiceEndpoints.smsTemplates}/${id}`, data);
  return response.data;
}

export async function deleteSmsTemplate(id: string, axiosInstance?: AxiosInstance): Promise<boolean> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.delete(`${apiConfig.voiceEndpoints.smsTemplates}/${id}`);
  return response.status === 200;
}

export async function previewSmsTemplate(body: string, variables: Record<string, string>, outcome: string, axiosInstance?: AxiosInstance): Promise<string> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<{ rendered: string }>(`${apiConfig.voiceEndpoints.smsTemplates}/preview`, { body, variables, outcome });
  return response.data.rendered;
}

export async function fetchSmsMergeVars(axiosInstance?: AxiosInstance): Promise<string[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<{ merge_vars: string[] }>(`${apiConfig.voiceEndpoints.smsTemplates}/merge-vars`);
  return response.data.merge_vars;
}
